module.exports = __webpack_public_path__ + "img/gal-2.dcf32450.jpg";